module.exports = __webpack_public_path__ + "img/security-audit-img-5.6dd4d86d.png";